import { request, PlanError } from './aiPlansApi';
import { TextHistoryItem, validHistoryPage } from './aiPlanTextApi';
export interface ConferenceItem extends TextHistoryItem {
 reason: string | null; diagnostic: { version: 1; fields: Array<{ field: string; type: string }> } | null; canReleaseNoSend: boolean;
}
export interface ConferencePage { items: ConferenceItem[]; nextOffset: number | null; }
export async function listConferences(token: string, offset: number, signal?: AbortSignal): Promise<ConferencePage> {
 const value = await request('/v1/admin/ai-plan-reconciliation/list', token, 'POST', { offset }, signal);
 if (!validHistoryPage(value) || !value.items.every((i: any) => typeof i.canReleaseNoSend === 'boolean'
  && (i.reason === null || (typeof i.reason === 'string' && /^[a-z_]{1,80}$/.test(i.reason)))
  && (i.diagnostic === null || (i.diagnostic.version === 1 && Array.isArray(i.diagnostic.fields) && i.diagnostic.fields.length <= 16
   && i.diagnostic.fields.every((f: any) => f && typeof f.field === 'string' && (f.field === '[redacted]' || /^[a-z][a-z0-9_]{0,63}$/.test(f.field)) && ['null','bool','int','float','string','array','stdClass'].includes(f.type)))))) {
  throw new PlanError(502, 'Resposta de conferência inválida.');
 }
 return value as ConferencePage;
}
export async function releaseNoSend(token: string, item: ConferenceItem, reference: string, sha256: string): Promise<void> {
 const data = await request('/v1/admin/ai-plan-reconciliation/release-no-send', token, 'POST',
  { callId: item.callId, contractId: item.scope.contractId, proof: { reference, sha256, confirmedNoSend: true } });
 if (data?.callId !== item.callId || data?.contractId !== item.scope.contractId || data?.state !== 'released') throw new PlanError(502, 'Não foi possível confirmar a liberação. Atualize a lista.');
}
